var map = {
	"./arrow-down.svg": 45389,
	"./arrow-left.svg": 48406,
	"./arrow-right.svg": 12917,
	"./arrow-up.svg": 11986,
	"./close.svg": 44543,
	"./download.svg": 22089,
	"./drag.svg": 91431,
	"./email.svg": 43367,
	"./exit.svg": 52781,
	"./expand.svg": 22029,
	"./export.svg": 90951,
	"./house.svg": 28003,
	"./info.svg": 81289,
	"./minus.svg": 70479,
	"./password.svg": 26802,
	"./pie-chart.svg": 17698,
	"./population.svg": 54176,
	"./refresh.svg": 98206,
	"./search-globe.svg": 10377,
	"./trend-down.svg": 22387,
	"./trend-house.svg": 52141,
	"./trend-unit.svg": 8737,
	"./trend-up.svg": 57004,
	"./unit.svg": 95991
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 65779;